import React from "react";
import { NIVEIS_APOIO, PESSOAS } from "../data/team";

/**
 * A escada de acionamento de cada titular, para consulta.
 * Fica fora da escala do mês de propósito: é informação fixa, e repetir os
 * quatro nomes em cada linha de dia só polui a leitura da escala.
 */
export default function MatrizApoio({ time }) {
  return (
    <section className="matriz" aria-labelledby="matriz-titulo">
      <header className="secao__cabecalho">
        <h2 id="matriz-titulo">Quem apoia quem</h2>
        <p className="secao__descricao">
          Ordem fixa definida pelo time. Vale para qualquer dia do rodízio.
        </p>
      </header>

      <ul className="matriz__lista">
        {time.map((id) => (
          <li key={id} className="matriz__item">
            <span className="matriz__titular">
              <img className="avatar avatar--sm" src={PESSOAS[id].foto} alt="" />
              {PESSOAS[id].primeiroNome}
            </span>
            <ol className="matriz__cadeia">
              {(NIVEIS_APOIO[id] || []).map((apoioId, i) => (
                <li key={apoioId}>
                  <a
                    className="matriz__elo"
                    href={PESSOAS[apoioId].whatsapp}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="matriz__ordem" aria-hidden="true">
                      {i + 1}
                    </span>
                    {PESSOAS[apoioId].primeiroNome}
                  </a>
                </li>
              ))}
            </ol>
          </li>
        ))}
      </ul>
    </section>
  );
}
